<template>
    <!-- <div class="button-wrap" style="z-index: 100; position: relative;" >
        <button class="btn btn-default" @click="setMode('LINE');">线段</button>
        <button class="btn btn-default" @click="setMode('POLYLINE');">多段线</button>
        <button class="btn btn-default" @click="setMode('RECT');">矩形</button>
        <button class="btn btn-default" @click="setMode('POLYGON');">多边形</button>
        <button class="btn btn-default" @click="getFeatures();">获取标注数据</button>
      </div>
  -->

 
  <a-card class="relative">
    <a-button class="back" @click="backHandle">返回</a-button>
    <Globalnfo :info="detail.info"></Globalnfo>
   <!-- {{ labelData.list }} -->
    <a-tabs v-model:activeKey="detail.activeKey" @change="taskChange" v-if="detail.from !='main'">
      <a-tab-pane :key="item.id" :tab="item.number" v-for="item in detail.subTask">
        <a-card class="mt20" title="基本信息" v-if="detail.from != 'main'">
          <div class="wrap">
            <div class="con">
              <dl>
                <dt>状态：</dt>
                <dd>{{ detail.subInfo.state }}</dd>
              </dl>
            
            </div>
          
            <div class="con">
              <dl>
                <dt>数量：</dt>
                <dd>{{detail.subInfo.detailTotal}}</dd>
              </dl>
              <dl>
                <dt>标注员：</dt>
                <dd>{{detail.subInfo.labelerName}}</dd>
              </dl>
              <dl>
                <dt>质检员：</dt>
                <dd>{{detail.subInfo.inspectorName}}</dd>
              </dl>
            </div>

          </div>
        </a-card>

        <a-card class="label-wrap mt20" title="标注数据">
          <div class="hd mb20">
            <div>
              <a-checkbox v-model:checked="checked">全选</a-checkbox> 
              <a-button class="mr15">通过</a-button>
              <a-button>不通过</a-button>
            </div>
            <div>
              <a-button type="primary">初验通过</a-button>
              <a-button class="ml20" type="primary">初验不通过</a-button>
            </div>
          </div>
          <ul class="label-list">
            <li v-for="(item, index) in labelData.list" :key="item.id">
              <figure>
                <!-- appConfig.baseImgUrl + item.item.accessSrc  --> 
                <a-image
                  @click="previewImg(index)"
                  :preview="false"
                  :src="appConfig.baseImgUrl + item.item.accessSrc"
                  fallback="data:image/png;base64,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"
                >
                </a-image>
                <figcaption class="name">{{item.item.accessSrc.split('/')[item.item.accessSrc.split('/').length-1]}}</figcaption>
              </figure>
            </li>

          </ul>
          <div class="mt20">
            <a-pagination
            style="float:right;margin-right: 30px;"
            v-model:current="labelData.page.num"
            show-quick-jumper
            :pageSize=labelData.page.size
            :total="labelData.page.total"
            :show-total="total => `共 ${total} 条`"
            @change="getDataItem"
          ></a-pagination>
          </div>
        </a-card>
      </a-tab-pane>
      
    </a-tabs>    
    


  </a-card>

  <div v-show="false"  @cancel="viewData.visible = false"  title="查看结果" :footer="null"
    :before-close="handleClose"
    width="90%">
  
    <div class="m-body flex">
      <div class="tc">
        <div class="img-wrap mb20" @click="fullView(viewData.curData.previewPath)">
          <div id="map" style="border: 1px dashed #ccc; position:relative;width:500px;height:300px;overflow: hidden; margin:0 auto;" >
          </div>
          <!-- <img :src="getViewUrl(viewData.curData.previewPath)" /> -->
        </div>
        
      </div>
    
      <div class="ml20 result-wrap relative">
        <p class="mb10 tc filename">数据文件名称：<span>{{viewData.curData.dataName}}</span></p>
        <p class="mb10 mt15">识别结果：</p>
        <div class="result-wrap-text mb10">
          <json-viewer 
          :value="viewData.curData.result"
          copyable
          :expand-depth="5"
          :show-array-index="false"
          ></json-viewer>
        </div>
        <div>
          <dl>
            <dt>质检状态：</dt>
            <dd>通过</dd>
          </dl>
          <dl>
            <dt>初验状态：</dt>
            <dd>通过</dd>
          </dl>
          <a-button>通过</a-button>
          <a-button>不通过</a-button>
        </div>
        <div class="btn-wrap tc">
          <a-button type="primary" @click="prevResult" class="mr20">上一张</a-button>
          <a-button type="primary" @click="nextResult">下一张</a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Globalnfo from './Globalnfo'
import {useRoute} from 'vue-router'
import {forView,subForView, dataItem} from '@/api/taskRelease'
import {reactive, getCurrentInstance, onMounted} from 'vue'
import AILabel from "ailabel"
import {mapState} from 'vuex'
import router from '../../../router'
export default {
  components:{
    Globalnfo
  },

  data(){
    return {
      chooseData:[],
      imgUrl: 'https://test-dev.westwell-research.com/testing/preview/files/wellspring/alphaceph/projects/welltesting-dev/2023022300005/CAL_2023022300005_01/images/00be8d6f276b48829e4608a19662d4eb.jpg',
      drawingStyle: {},
      mode: '',
      itemName: '',
      editId: '',
      deleteIconId: 'delete01'

    }
  },
  watch: {
    mode(mode) {
      this.gMap.setMode(mode);
      this.setDrawingStyle(mode);
    }
  },
  computed: {
    ...mapState(['appConfig'])
  },
  methods:{
    previewImg(index){
      console.log(this.labelData.list.length)
      let tmp = JSON.parse(JSON.stringify(this.labelData.list))
      let arr = []
     
      for (let index in tmp){
        arr.push(tmp[index])
      }

      let arr2 = arr.map((item)=>{
        return this.appConfig.baseImgUrl + item.item.accessSrc
      })
   
      this.$hevueImgPreview({
        multiple: true, // 开启多图预览模式
        nowImgIndex: index, // 多图预览，默认展示第二张图片
        imgList: arr2, // 需要预览的多图数组,
        changeFn(img){
          console.log(img)
          if(img.fromImgIndex == 0){
          }
        }
      }) 
    },
    zoomIn() {
      this.gMap.zoomIn();
    },
    zoomOut() {
      this.gMap.zoomOut();
    },
    setMode(mode) {
      this.mode = mode;
    },
    // 获取所有features
    getFeatures() {
      const allFeatures = this.gFirstFeatureLayer.getAllFeatures();
       
      console.log('--allFeatures--', allFeatures);
     
      return allFeatures
       //JSON.parse(JSON.stringify(allFeatures))
    },
    // 初始样式
    setDrawingStyle(mode) {
      let drawingStyle = {};
      switch (mode) {
        case 'PAN': {
          break;
        }
        case 'MARKER': {
          // 忽略
          break;
        }
        case 'POINT': {
          this.drawingStyle = {fillStyle: '#9370DB'};
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'CIRCLE': {
          this.drawingStyle = {fillStyle: '#9370DB', strokeStyle: '#0000FF', lineWidth: 2};
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'LINE': {
          this.drawingStyle = {
            strokeStyle: '#FF00FF',
            lineJoin: 'round',
            lineCap: 'round',
            lineWidth: 10,
            arrow: false
          };
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'POLYLINE': {
          this.drawingStyle = {strokeStyle: '#FF1493', lineJoin: 'round', lineCap: 'round', lineWidth: 10}
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'RECT': {
          this.drawingStyle = {strokeStyle: '#0f0', lineWidth: 1}
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'POLYGON': {
          this.drawingStyle = {
            strokeStyle: '#00f',
            fillStyle: '#0f0',
            globalAlpha: .3,
            lineWidth: 1,
            fill: true,
            stroke: true
          }
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'DRAWMASK': {
          this.drawingStyle = {strokeStyle: 'rgba(255, 0, 0, .5)', fillStyle: '#00f', lineWidth: 50}
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        case 'CLEARMASK': {
          this.drawingStyle = {fillStyle: '#00f', lineWidth: 30}
          this.gMap.setDrawingStyle(drawingStyle);
          break;
        }
        default:
          break;
      }
    },
    // 添加图形
    addFeature(data, type, name) {
      let that = this;
      let drawingStyle = this.drawingStyle;
      if (type === 'LINE') {
        const scale = that.gMap.getScale();
        const width = drawingStyle.lineWidth / scale;
        const lineFeature = new AILabel.Feature.Line(
          `${+new Date()}`, // id
          {...data, width}, // shape
          {name}, // props
          drawingStyle // style
        );
        that.gFirstFeatureLayer.addFeature(lineFeature);
      } else if (type === 'POLYLINE') {
        const scale = that.gMap.getScale();
        const width = drawingStyle.lineWidth / scale;
        const polylineFeature = new AILabel.Feature.Polyline(
          `${+new Date()}`, // id
          {points: data, width}, // shape
          {name}, // props
          drawingStyle // style
        );
        that.gFirstFeatureLayer.addFeature(polylineFeature);
      } else if (type === 'RECT') {
        const rectFeature = new AILabel.Feature.Rect(
          `${+new Date()}`, // id
          data, // shape
          {name}, // props
          drawingStyle // style
        );
        that.gFirstFeatureLayer.addFeature(rectFeature);
      } else if (type === 'POLYGON') {
        const polygonFeature = new AILabel.Feature.Polygon(
          `${+new Date()}`, // id
          {points: data}, // shape
          {name}, // props
          drawingStyle // style
        );
        that.gFirstFeatureLayer.addFeature(polygonFeature);
      }
    },
    // 获取历史数据
    getHistoryData() {
      const gFirstMaskLayer = new AILabel.Layer.Mask(
        'first-layer-mask', // id
        {name: '第一个涂抹图层'}, // props
        {zIndex: 11, opacity: .5} // style
      );
      this.gMap.addLayer(gFirstMaskLayer);

      const gFirstTextLayer = new AILabel.Layer.Text(
        'first-layer-text', // id
        {name: '第一个文本图层'}, // props
        {zIndex: 12, opacity: 1} // style
      );
      this.gMap.addLayer(gFirstTextLayer);

      const gFirstText = new AILabel.Text(
        'first-text', // id
        {text: '中华人民共和国', position: {x: 300, y: 300}, offset: {x: 0, y: 0}}, // shape
        {name: '第一个文本对象'}, // props
        {fillStyle: '#F4A460', strokeStyle: '#D2691E', background: true, globalAlpha: 1, fontColor: '#0f0'} // style
      );
      gFirstTextLayer.addText(gFirstText);

      const gFirstFeaturePoint = new AILabel.Feature.Point(
        'first-feature-point', // id
        {x: 250, y: 177, sr: 3}, // shape
        {name: '第一个矢量图层'}, // props
        {fillStyle: '#f00', lineCap: 'round'} // style
      );
      this.gFirstFeatureLayer.addFeature(gFirstFeaturePoint);

      const gFirstFeatureCircle = new AILabel.Feature.Circle(
        'first-feature-circle', // id
        {cx: 100, cy: 100, sr: 20}, // shape
        {name: '第一个矢量图层'}, // props
        {fillStyle: '#F4A460', strokeStyle: '#00f', lineWidth: 1, stroke: true, fill: false} // style
      );
      this.gFirstFeatureLayer.addFeature(gFirstFeatureCircle);

      const gFirstFeatureLine = new AILabel.Feature.Line(
        'first-feature-line', // id
        {start: {x: 100, y: 150}, end: {x: 200, y: 250}, width: 10}, // shape
        {name: '第一个矢量图层'}, // props
        {strokeStyle: '#FF4500', lineCap: 'round'} // style
      );
      this.gFirstFeatureLayer.addFeature(gFirstFeatureLine);
      const gFirstFeatureRect = new AILabel.Feature.Rect(
        'first-feature-rect', // id
        {x: 200, y: 50, width: 100, height: 100}, // shape
        {name: '第一个矢量图层'}, // props
        {strokeStyle: '#00f', lineWidth: 1, fillStyle: '#00f', globalAlpha: .3, fill: true} // style
      );
      this.gFirstFeatureLayer.addFeature(gFirstFeatureRect);
      const gFirstFeaturePolygon = new AILabel.Feature.Polygon(
        'first-feature-polygon', // id
        {
          points: [
            {x: 367, y: 161}, {x: 371, y: 220}, {x: 412, y: 241},
            {x: 474, y: 210}, {x: 467, y: 151}, {x: 426, y: 124}
          ]
        }, // shape
        {name: '第一个多边形'}, // props
        {strokeStyle: '#0000FF', lineWidth: 1} // style
      );
      this.gFirstFeatureLayer.addFeature(gFirstFeaturePolygon);
      console.log('--AILabel--', AILabel);
    },
    // 画完取名
    getName(mode) {
      return this.$prompt('请输入填写名字', {
        confirmButtonText: '确定',
        showCancelButton: false
      }).then(({value}) => {
        this.itemName = value;
        return value;
      }).catch(() => {
        return null;
      });
    },
    // 增加删除图标
    addDeleteIcon(feature) {
      let gMap = this.gMap;
      let that = this;
      // 添加delete-icon
      let points = that.getPoints(feature);
      console.log(points);
      const gFirstMarker = new AILabel.Marker(
        that.deleteIconId, // id
        {
          src: '../../static/img/delete.png',
          position: points[1], // 矩形右上角
          offset: {
            x: -20,
            y: -4
          }
        }, // markerInfo
        {name: 'delete'} // props
      );
      gFirstMarker.events.on('click', marker => {
        // 首先删除当前marker
        gMap.markerLayer.removeMarkerById(marker.id);
        // 删除对应text
        // gFirstTextLayer.removeTextById(textId);
        // 删除对应feature
        that.gFirstFeatureLayer.removeFeatureById(feature.id);
      });
      gMap.markerLayer.addMarker(gFirstMarker);
    },
    // 删除 删除按钮
    deIcon() {
      this.gMap.markerLayer.removeAllMarkers();
    },
    // 增加事件
    addEvent() {
      let that = this;
      let gMap = this.gMap;
      
      // 绘制结束时触发
      gMap.events.on('drawDone', (type, data) => {
        console.log('--type, data--', type, data);
        that.addFeature(data, type);

        let arr = that.getFeatures()
          console.log('arr')
          arr.forEach((item)=>{
            this.chooseData.push({
              id:1
            })
          })
          this.chooseData[0] = arr[0].id
          //console.log(arr[0].id)
      
        /*that.getName(type).then(val => {
          if (val) {
            that.addFeature(data, type, val);
          } else {
            this.$message({
              type: 'info',
              message: '请填写名字'
            });
          }
        })*/
      });
      // 视野范围发生变化
      gMap.events.on('boundsChanged', data => {
      
        console.log('--map boundsChanged--', data);
        return '';
      });
      // 双击编辑
      gMap.events.on('featureSelected', feature => {
        that.editId = feature.id;
        // console.log('--map featureSelected--', feature);
        gMap.setActiveFeature(feature);
        // 增加删除按钮
        that.addDeleteIcon(feature);
        let arr = gMap.getActiveFeature()
        console.log('getActiveFeature')
        console.log(arr)
        //console.log(gMap.getTargetFeatureWithPoint(point))
      });
      // 单机空白取消编辑    当模式切换或单击其他地方触发
      gMap.events.on('featureUnselected', () => {
        // 取消featureSelected
        that.editId = '';
        that.deIcon();
        gMap.setActiveFeature(null);
      });
      // 更新完  feature编辑完成触发
      gMap.events.on('featureUpdated', (feature, shape) => {
        console.log(feature);
        // 更新或者移动需要重新设置删除图标
        that.deIcon();
        feature.updateShape(shape);
        that.addDeleteIcon(feature);
      });
      // 删除   目前只针对点双击选中右键触发
      gMap.events.on('FeatureDeleted', () => {
        console.log(2222222);
        // that.gFirstFeatureLayer.removeFeatureById(that.editId);
      });
    },
    // 获取坐标
    getPoints(feature) {
      switch (feature.type) {
        case 'RECT':
          return feature.getPoints();
        case 'LINE':
          return [
            feature.shape.start,
            feature.shape.end,
          ];
        case 'POLYLINE':
          return feature.shape.points;
        case 'POLYGON':
          return feature.shape.points;
        default:
          return [];
      }
    }
  },
  setup(){
    const instance = getCurrentInstance()
    const route = useRoute()

    const labelTaskId = route.query.taskId || ''
    const labelTaskSubId = route.query.subId || ''
    
    const detail = reactive({    
      from:'',
      info:{
        dataset:{},
        project:{},
        purchaseManager:{}  
      },
      subInfo:{

      },
      subTask:[],
      activeKey:'',
    })

    detail.from = route.query.from
    detail.subTask = JSON.parse(localStorage.getItem('subTask'))   
    //detail.activeKey =  detail.subTask[0].id
    detail.activeKey = route.query.subId

    const itemData = reactive({    
      list:[],
      page:{
        num:1,
        size:10,
        total:0
      }
    })


    const labelData = reactive({    
      list:[],
      page:{
        num:1,
        size:10,
        total:0
      }
    })
    
    let subLabelData = reactive({
      list:[],
      page:{
        num:1,
        size:10,
        total:0
      }
    })
    
      

    async function getDataItem(){
      let from = route.query.from
      let params = {
        //labelTaskSubId, 
        pageNum:labelData.page.num,
        pageSize:labelData.page.size,
      }
      if(from == 'main'){
        params.labelTaskId = labelTaskId
      }else{
        params.labelTaskSubId = labelTaskSubId
      }
      
      const {data:res} = await dataItem(params)
      labelData.page.total = res.data.total
      labelData.list = {...res.data.records}
    }


   
    /*  查看结果   */
    let viewData = {
      visible:false,
      curData:{
        previewPath:'https://test-dev.westwell-research.com/testing/preview/files/wellspring/alphaceph/projects/welltesting-dev/2023022300005/CAL_2023022300005_01/images/00be8d6f276b48829e4608a19662d4eb.jpg',
        dataName:'',
      },

    } 

    function prevResult(){

    }

    function nextResult(){
    
    }


    function getViewUrl(src){
      return src
    }



    function handleClose(){

    }


    function fullView(){

    }


    // 查看总任务详情
    async function getForView(){
      let params = {
        labelTaskId
      }
      const {data:res} = await forView(params)
      detail.info = {...res.data}
      
    }

    getForView()
    

    async function getSubForView(){
      let params = {
        labelTaskSubId:detail.activeKey
      }
      debugger
      const {data:res} = await subForView(params)
      detail.subInfo = {...res.data}
      
    }

   
    
    function taskChange(activeKey){
      console.log(activeKey)
    }
    // function previewImg(url){
    
      
    //   hevueImgPreview(url)
    // }


    function backHandle(){
      router.back()
    }
    
    onMounted(()=>{
      getDataItem()
      getSubForView()

      // instance.proxy.$nextTick(()=>{
      //   alert(666)
      // })
      //instance.proxy.$forceUpdate()

    })  

    return {
      detail,
      labelData,
      getForView,
      getSubForView,
      getDataItem,
      itemData,
      viewData,
      handleClose,
      fullView,
      prevResult,
      nextResult,
      getViewUrl,
      taskChange,
      backHandle,
      //previewImg,
    
    }

  },
  mounted(){
    let that = this;

    const gMap = new AILabel.Map('map', {
      center: {x: 250, y: 150}, // 为了让图片居中
      zoom: 500,
      mode: 'BAN', // 绘制线段  PAN
      refreshDelayWhenZooming: true, // 缩放时是否允许刷新延时，性能更优
      zoomWhenDrawing: true,
      panWhenDrawing: true,
      zoomWheelRatio: 5, // 控制滑轮缩放缩率[0, 10), 值越小，则缩放越快，反之越慢
      withHotKeys: true // 关闭快捷键
    });
    //gMap.setEditingColor('#FFF');
    that.gMap = gMap;
    this.addEvent();
    // 图片层添加
    const gFirstImageLayer = new AILabel.Layer.Image(
      'first-layer-image', // id
      {
        src: that.imgUrl,
        width: '500',
        height: '300',
        crossOrigin: false, // 如果跨域图片，需要设置为true
        position: { // 左上角相对中心点偏移量
          x: 0,
          y: 0
        },
        // grid: { // 3 * 3
        //   columns: [{color: '#9370DB'}, {color: '#FF6347'}],
        //   rows: [{color: '#9370DB'}, {color: '#FF6347'}]
        // }
      }, // imageInfo
      {name: '第一个图片图层'}, // props
      {zIndex: 5} // style
    );
    // 添加到gMap对象
    gMap.addLayer(gFirstImageLayer);
    // 添加矢量图层
    const gFirstFeatureLayer = new AILabel.Layer.Feature(
      'first-layer-feature', // id
      {name: '第一个矢量图层'}, // props
      {zIndex: 10} // style
    );
    this.gFirstFeatureLayer = gFirstFeatureLayer;
    gMap.addLayer(gFirstFeatureLayer);
    // 历史
     //this.getHistoryData();
    window.onresize = function () {
      this.gMap && this.gMap.resize();
    }

  },
  beforbeforeDestroy(){
    this.gMap.destroy();
  }

}
</script>
<style lang="less" scoped>
  .back{
    position: absolute;
    right: 50px;
    top:50px;
    z-index: 1;
  }
  .wrap{
    .con{
      display: flex;
      margin-right: 200px;
      dl{
        display: flex;
        
      }
    }
  }
  .label-wrap{
      .hd{
        display: flex;
        justify-content: space-between;
      }
    }
  .label-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    li{
      position: relative;
      width: 280px;
      height: 208px;
      overflow: hidden;
      display: inline-block;
      margin: 0 20px 30px 20px;
      border:1px solid #ccc;
      text-align: center;
     
      box-sizing: content-box;
      
      .name{
        margin-top: 10px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: center;
        line-height: 50px;
        background: rgba(0,0,0,0.1);
      }
    }
  }

  .label-list:after{
    content: '';
    width: 285px;
  }
  .img-wrap{
    display: flex;
    justify-content:center;
    align-items: center;
    // border:1px solid #ddd;
    box-shadow:0px 0px 3px #ddd;
    width:750px;
    height: 400px;
    img {
      max-width:400px;
      max-height: 400px;
    }
  
  }
  .filename{
      font-weight: bold;
      font-size:16px;
    }

  .result-wrap{
    width:100%;
    .result-wrap-text{
    
      height: 290px;;
      border:1px solid #dcdcdc;
      overflow-y: auto;
      padding: 5px;
    }
  }

  
</style>
